"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageConnectorEndsError = exports.PAGE_CONNECTOR_ENDS_ORIGIN = exports.PAGE_CONNECTOR_END_KEYS = void 0;
exports.readPageConnectorEnds = readPageConnectorEnds;
/** Connector fields whose ids the entry of the connector repeats as c. */
exports.PAGE_CONNECTOR_END_KEYS = ['source', 'target'];
/**
 * Origin of the writes that repeat connector ends from the fields after a
 * concurrent write of the entry: no step of the history.
 */
exports.PAGE_CONNECTOR_ENDS_ORIGIN = Symbol('page-connector-ends');
/** A connector end field is no connection. */
class PageConnectorEndsError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'PageConnectorEndsError';
    }
}
exports.PageConnectorEndsError = PageConnectorEndsError;
// A connection is { id } or { position }; an unset field is a free end.
function endId(connectorId, key, value) {
    if (value === undefined)
        return null;
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        throw new PageConnectorEndsError(`Invalid ${key} of ${connectorId}`);
    const { id } = value;
    if (id === undefined)
        return null;
    if (typeof id !== 'string' || id.length === 0)
        throw new PageConnectorEndsError(`Invalid ${key} id of ${connectorId}`);
    return id;
}
/** The ids of the ends a connector is attached to, from its fields. */
function readPageConnectorEnds(connectorId, fields) {
    return [
        endId(connectorId, 'source', fields.get('source')),
        endId(connectorId, 'target', fields.get('target')),
    ];
}
